var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchbox landing"},[_c('form',{ref:"searchboxForm",attrs:{"action":"","method":"post","autocomplete":"off"}},[_c('option-apr')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }